import { enrich } from './yupEnrichment'
import { ObjectSchema, SchemaDescription, string, object, mixed, StringSchema, InferType } from 'yup'
import { BaseDataItem } from '../structureTypes'
import { defaultProperties } from './Core.schema'

enrich(object)

type DefaultProperties = InferType<typeof defaultProperties>

export type DataSchema<Schema extends ObjectSchema, Type extends string> = ObjectSchema<
	BaseDataItem<Type> & InferType<Schema>
>
export type PropertiesSchema<Schema extends ObjectSchema, Type extends string> = DataSchema<Schema, Type> &
	DefaultProperties

type SchemasMap<T extends ObjectSchema> = { [type: string]: T }

export interface DataRefSchemaDescription<T extends ObjectSchema> extends SchemaDescription {
	meta: { schemas: SchemasMap<T> }
}

export const createDataRef = <T extends ObjectSchema>(schemas: SchemasMap<T>): StringSchema =>
	string().meta({ schemas })

export const createWeakDataRef = (schemaType: string): StringSchema => string().meta({ schemaType, weakRef: true })

const createSchema = <Type extends string, Schema extends object>(
	type: Type,
	schema: ObjectSchema<Schema>
): ObjectSchema<BaseDataItem<Type> & Schema> => {
	const baseSchema = object({
		id: string().required(),
		type: mixed<Type>().oneOf([type]).default(type),
	})

	return schema.concat(baseSchema)
}

export { createSchema as createDataSchema }

export const createPropertiesSchema = <Type extends string, Schema extends object>(
	type: Type,
	schema: ObjectSchema<Schema>
): ObjectSchema<BaseDataItem<Type> & Schema & DefaultProperties> => createSchema(type, schema).concat(defaultProperties)

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U]
